import { hasCloud } from '../has_cloud'
import { StateMapDisk } from './state_map_disk.enum'
import { hasIndexedDB } from '../Storage/IndexedDB/hasIndexedDB'

export function getDefaultStateMapDisk(): StateMapDisk {
  if (hasIndexedDB()) {
    return StateMapDisk.IndexedDB
  }
  if (hasCloud) {
    return StateMapDisk.Cloud
  }
  throw new Error('No supported disk available (IndexedDB and Cloud are both unavailable)')
}
